import { Skeleton } from "@/components/ui/skeleton";

// Same blocks as EngageCampaignDetail: breadcrumb, title with its status, the description, the stats strip, the stage tabs
// and the activation cards. It stands in for the page while its code and the campaign load.
// Keep it in step with the page.
const CampaignDetailSkeleton = () => (
  <div className="min-h-screen" aria-busy="true" aria-label="Loading">
    <main className="py-6 pt-10">
      <div className="ernest-container">
        <Skeleton className="mb-6 h-5 w-56" />
        <div className="mb-8">
          <div className="flex items-center gap-3">
            <Skeleton className="h-9 w-64" />
            <Skeleton className="h-7 w-20 rounded-full" />
          </div>
          <Skeleton className="mt-3 h-6 w-96 max-w-full" />
        </div>
        <div className="mb-8 grid grid-cols-2 gap-3 lg:grid-cols-6">
          {[0, 1, 2, 3, 4, 5].map((i) => <Skeleton key={i} className="h-[86px] rounded-2xl" />)}
        </div>
        <div className="space-y-5">
          {[0, 1].map((i) => <Skeleton key={i} className="h-[132px] rounded-xl" />)}
        </div>
      </div>
    </main>
  </div>
);

export default CampaignDetailSkeleton;
